import { FreeFieldCategoryDetailSection } from "FreeFieldCategory/FreeFieldCategoryDetailSection";
import FreeFieldCategoryOptionsPanel from "FreeFieldCategory/FreeFieldCategoryOptionsPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";

const FreeFieldCategoryDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.FreeFieldCategoryDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <FreeFieldCategoryDetailSection
        freeFieldCategory={viewModel.freeFieldCategoryDto}
        freeFieldDefinitions={viewModel.freeFieldDefinitions}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <FreeFieldCategoryOptionsPanel
        optionsPanelData={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
        freeFieldCategoryId={viewModel.freeFieldCategoryDto.freeFieldCategoryId}
        mainArea={viewModel.freeFieldCategoryDto.mainArea}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default FreeFieldCategoryDetailApp;